export default {
  'common.save': '儲存',
  'common.cancel': '取消',
  'common.delete': '刪除',
  'common.edit': '編輯',
  'common.confirm': '確認',
  'common.close': '關閉',
  'common.search': '搜尋',
  'common.loading': '載入中...',
  'common.processing': '處理中...',
  'common.submit': '提交',
  'common.back': '返回',
  'common.next': '下一步',
  'common.previous': '上一步',
  'common.upload': '上傳',
  'common.download': '下載',
  'common.downloadAll': '全部下載',
  'common.refresh': '重新整理',
  'common.retry': '重試',
  'common.copy': '複製',
  'common.copied': '已複製',
  'common.selectAll': '全選',
  'common.clear': '清除',
  'common.clearAll': '全部清除',
  'common.apply': '套用',
  'common.reset': '重設',
  'common.filter': '篩選',
  'common.sort': '排序',
  'common.export': '匯出',
  'common.import': '匯入',
  'common.preview': '預覽',
  'common.view': '檢視',
  'common.add': '新增',
  'common.remove': '移除',
  'common.rename': '重新命名',
  'common.share': '分享',
  'common.settings': '設定',
  'common.logout': '登出',
  'common.profile': '個人資料',
  'common.yes': '是',
  'common.no': '否',
  'common.ok': '確定',
  'common.areYouSure': '您確定嗎？',
  'common.actionCannotBeUndone': '此操作無法復原。',
  'common.noData': '暫無資料',
  'common.noResultsFound': '找不到結果',
  'common.somethingWentWrong': '發生錯誤',
  'common.pleaseTryAgain': '請再試一次',
  'common.success': '成功',
  'common.error': '錯誤',
  'common.warning': '警告',
  'common.info': '資訊',
  'common.optional': '選填',
  'common.required': '必填',
  'common.name': '名稱',
  'common.title': '標題',
  'common.description': '描述',
  'common.status': '狀態',
  'common.actions': '操作',
  'common.date': '日期',
  'common.time': '時間',
  'common.createdAt': '建立時間',
  'common.updatedAt': '更新時間',
  'common.type': '類型',
  'common.size': '大小',
  'common.file': '檔案',
  'common.folder': '資料夾',
  'common.files': '檔案',
  'common.folders': '資料夾',
  'common.all': '全部',
  'common.none': '無',
  'common.send': '傳送',
  'common.sending': '傳送中...',
  'common.new': '新建',
  'common.create': '建立',
  'common.duplicate': '複製',
  'common.move': '移動',
  'common.moveTo': '移動到',
  'common.selectFile': '選擇檔案',
  'common.chooseFile': '選擇檔案',
  'common.dragDropFilesHere': '將檔案拖放到此處',
  'common.or': '或',
  'common.browse': '瀏覽',
  'common.continue': '繼續',
  'common.skip': '略過',
  'common.done': '完成',
  'common.finish': '完成',
  'common.start': '開始',
  'common.stop': '停止',
  'common.pause': '暫停',
  'common.resume': '繼續',
  'common.enabled': '已啟用',
  'common.disabled': '已停用',
  'common.active': '啟用',
  'common.inactive': '未啟用',
  'common.draft': '草稿',
  'common.published': '已發佈',
  'common.archive': '封存',
  'common.unarchive': '取消封存',
  'common.favourite': '收藏',
  'common.favourites': '收藏夾',
  'common.pin': '釘選',
  'common.unpin': '取消釘選',
  'common.expand': '展開',
  'common.collapse': '收合',
  'common.showMore': '顯示更多',
  'common.showLess': '收合更多',
  'common.language': '語言',
  'common.darkMode': '深色模式',
  'common.lightMode': '淺色模式',
  'common.help': '說明',
  'common.feedback': '意見回饋',
  'common.notifications': '通知',
  'common.rows': '列',
  'common.column': '欄',
  'common.total': '總計',
  'common.page': '頁',
  'common.of': '/',
  'common.notes': '備註',
};
